const ADMINISTRATOR_GROUP_NAME = "administrator";

/**
 * UX-layer role check based on the current user's group names, as returned by
 * the /me endpoint. The backend permission classes are the real enforcement;
 * this only decides which controls are worth rendering.
 *
 * Note that `is_staff` is not a proxy for the administrator role in this
 * system - administrators are identified by group membership alone.
 */
export function isAdministrator(currentUserGroups?: string[]): boolean {
  return (currentUserGroups ?? []).some(
    (group) => group.toLowerCase() === ADMINISTRATOR_GROUP_NAME
  );
}
